import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import courseplanner from './planning/courseplanner'
import assignmentListing from './planning/assignmentListing'
import courseplannerListing from './planning/courseplannerListing'
import assignmentDetail from './planning/assignmentDetail'
import assignmentUsers from './planning/assignmentUsers'

import * as h2Api from '../h2Api'
import { ASSIGNMENT_SEQUENCE_LOADED } from '../actions/planning/assignments'

const initialCourseCreationForm = {
  courseId: null,
  name: '',
  description: ''
}
const initialAssignmentForm = {
  notes: ''
}
const planning = combineReducers({
  assignmentListing,
  assignmentDetail,
  assignmentUsers,
  courseplanner,
  courseplannerListing,
  lessonSequencePreviewRequest: h2Api.restReducer(ASSIGNMENT_SEQUENCE_LOADED),
  courseCreationForm: modelReducer(
    'planning.courseCreationForm',
    initialCourseCreationForm
  ),
  assignmentTaskForm: modelReducer('planning.assignmentTaskForm', initialAssignmentForm),
  forms: formReducer('planning', {
    courseCreationForm: initialCourseCreationForm,
    assignmentTaskForm: initialAssignmentForm
  })
})

export default planning
